function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h20l10 9.75V40H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#4286FE",
  fillRule: "nonzero",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 7h4a2 2 0 012 2v3a2 2 0 01-2 2H7.5A3.5 3.5 0 014 10.5V9a2 2 0 012-2zM14.5 7.636l.11-.046a1 1 0 011.39.92v3.98a1 1 0 01-1.39.92l-.11-.046a2.461 2.461 0 01-1.5-2.266V9.902c0-.988.59-1.88 1.5-2.266z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#95C3FF",
  fillRule: "nonzero",
  mask: "url(#b)",
  d: "M20 0h10v10H20z"
}));

var SvgZoom = function SvgZoom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZoom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom.661f2537.svg";
export { ForwardRef as ReactComponent };